import { readonly, ref } from 'vue';

const coinGiftDialogOpen = ref(false);
const onboardingDialogOpen = ref(false);
const dashboardDialogsReady = ref(false);

export function useDashboardDialogCoordinator() {
  return {
    coinGiftDialogOpen: readonly(coinGiftDialogOpen),
    onboardingDialogOpen: readonly(onboardingDialogOpen),
    dashboardDialogsReady: readonly(dashboardDialogsReady)
  };
}

export function resetDashboardDialogs() {
  coinGiftDialogOpen.value = false;
  onboardingDialogOpen.value = false;
  dashboardDialogsReady.value = false;
}

export function setCoinGiftDialogOpen(open: boolean) {
  coinGiftDialogOpen.value = open;
}

export function setOnboardingDialogOpen(open: boolean) {
  onboardingDialogOpen.value = open;
}

export function markDashboardDialogsReady() {
  dashboardDialogsReady.value = true;
}
